export const RU_POSTFIX_REGEX = /-ru$/g;

export const URL_REGEX =
  /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!\-/]))?/;

export const NUMBER_REGEX = /\[(.*?)\]/;

export const WHITESPACE_REGEX = /(\s+)/;

export const COUNTRY_CODE_REGEX = /(!\w\w)/;

export const NEW_COUNTRY_CODE_REGEX = /\[!flag:\s?(\w{2})\]/g;

export const QUOTES_REGEX = /["']/g;
export const SPACE_AFTER_FLAG_REGEX = /!(\w{2})\s/g;

export const YEAR_REGEX = /(!year)/;

export const VOWEL_REGEX = /^[aeiou]/i;

export const ANCHOR_REGEX = /#.*/;

export const WIDTH_X_HEIGHT_REGEX =
  /(\d+(\.\d+|)\s?x\s?\d+(\.\d+|)(\s?x\s?\d*(\.?\d+|))?)/gi;

export const PHONE_REGEX =
  /^(\+?\d{1,3})[\s-]?\(?\d{1,4}\)?[\s-]?\d{1,4}[\s-]?\d{1,4}[\s-]?\d{1,4}$/;

export const HEX_COLOR_REGEX = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
